import { render } from "./LayoutIcon.vue?vue&type=template&id=498c80f4"
import script from "./LayoutIcon.vue?vue&type=script&lang=js"
export * from "./LayoutIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__